import { useQuery } from '@apollo/client';
import { DictionaryItem, QueryListResponse } from 'global';

import { calendarApi } from './index';
import { DealActivityAPINameSpace } from '../../api/types';

export function useCalendarFormOptions() {
  const { data: accountOptions, loading: accountOptionsLoading } = useQuery<
    DealActivityAPINameSpace<QueryListResponse<DictionaryItem>>
  >(calendarApi.calendarAccountOptions);
  const { data: contactOptions, loading: contactOptionsLoading } = useQuery<
    DealActivityAPINameSpace<QueryListResponse<DictionaryItem>>
  >(calendarApi.calendarContactOptions);

  return {
    contactOptionsLoading,
    accountOptionsLoading,
    accountOptions: accountOptions?.dealActivity?.result?.list ?? [],
    contactOptions: contactOptions?.dealActivity?.result?.list ?? [],
  };
}
